import { render, staticRenderFns } from "./RequestForExtension.vue?vue&type=template&id=291c1d70"
import script from "./RequestForExtension.vue?vue&type=script&lang=js"
export * from "./RequestForExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports